// Límite único de archivos en el frontend (sep-2026). Debe coincidir con
// backend/limites_archivos.py: 10 MB en todo el sistema, 25 MB solo para fotos de inmuebles
// (los inputs de ese caso se marcan con data-max-mb="25").
export const MAX_MB = 10;
export const EXT_DEFAULT = [".pdf", ".jpg", ".jpeg", ".png"];

const MIME_A_EXT = {
  "application/pdf": [".pdf"],
  "image/jpeg": [".jpg", ".jpeg"],
  "image/jpg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/webp": [".webp"],
  "image/*": [".jpg", ".jpeg", ".png", ".webp"],
  "text/csv": [".csv"],
  "application/xml": [".xml"],
  "text/xml": [".xml"],
};

// Traduce el atributo `accept` de un input a la lista de extensiones aceptadas.
export function extsDeAccept(accept) {
  const partes = String(accept || "").split(",").map((s) => s.trim().toLowerCase()).filter(Boolean);
  if (!partes.length) return EXT_DEFAULT;
  const exts = [];
  partes.forEach((p) => {
    if (p.startsWith(".")) exts.push(p);
    else if (MIME_A_EXT[p]) exts.push(...MIME_A_EXT[p]);
  });
  return exts.length ? [...new Set(exts)] : EXT_DEFAULT;
}

const etiquetas = (exts) => exts.map((e) => e.replace(".", "").toUpperCase()).join(", ");

// Devuelve el mensaje de error si el archivo no cumple, o null si está bien.
export function validarArchivo(file, { maxMB = MAX_MB, exts = EXT_DEFAULT } = {}) {
  if (!file) return null;
  const mb = file.size / (1024 * 1024);
  if (mb > maxMB) {
    return `El archivo pesa ${mb.toFixed(1)} MB; el máximo es ${maxMB} MB. `
      + "Comprime el archivo e inténtalo de nuevo.";
  }
  const nombre = (file.name || "").toLowerCase();
  if (exts?.length && !exts.some((e) => nombre.endsWith(e))) {
    return `Tipo de archivo no permitido. Formatos aceptados: ${etiquetas(exts)}.`;
  }
  return null;
}
